import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

const EMAILJS_SERVICE_ID = "service_3nqh3sr";
const EMAILJS_TEMPLATE_ID = "template_tjpo7dj";
const EMAILJS_PUBLIC_KEY = "HHublj2B24TUQ-OZt";

export const Contact = (props) => {
  const [, setState] = useState(initialState);
  const [status, setStatus] = useState(null); // null | "sending" | "success" | "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, e.target, EMAILJS_PUBLIC_KEY)
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          setStatus("success");
        },
        (error) => {
          console.log(error.text);
          setStatus("error");
        }
      );
  };
  const c =
    props.ui && props.ui.contact
      ? props.ui.contact
      : {
          title: "Get In Touch",
          intro:
            "Please fill out the form below to send us an email and we will get back to you as soon as possible.",
          namePlaceholder: "Name",
          emailPlaceholder: "Email",
          messagePlaceholder: "Message",
          send: "Send Message",
          sending: "Sending...",
          success: "Your message has been sent. Thank you!",
          error:
            "Something went wrong and your message could not be sent. Please try again, or reach us directly using the info below.",
          infoTitle: "Contact Info",
          phoneLabel: "Phone",
          emailLabel: "Email",
        };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{c.title}</h2>
                <p>{c.intro}</p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={c.namePlaceholder}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={c.emailPlaceholder}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={c.messagePlaceholder}
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success">
                  {status === "success" && (
                    <div className="alert alert-success">{c.success}</div>
                  )}
                  {status === "error" && (
                    <div className="alert alert-danger">{c.error}</div>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? c.sending : c.send}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{c.infoTitle}</h3>
              <p>
                <span>
                  <i className="fa fa-phone"></i> {c.phoneLabel}
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> {c.emailLabel}
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 Alexander Mestre. Github{" "}
            <a href="https://github.com/alexander-mestre" rel="nofollow">
              Alexander Mestre
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
